import cn from "classnames";
import Typography from "@mui/material/Typography";

import styles from "./ElementDetails.module.scss";

interface ElementDetailsProps {
  htmlComponentId: string;
  pathToElement: string;
  componentId: string;
}

function ElementDetails({ htmlComponentId, pathToElement, componentId }: ElementDetailsProps) {
  return (
    <>
      <div className={cn(styles.group, styles.column)}>
        <Typography
          variant="body2"
          className={styles.label}
        >
          Item Canonical:
        </Typography>
        <pre className={styles.pre}>
          <code>{htmlComponentId}</code>
        </pre>
      </div>
      <div className={styles.row}>
        <div className={cn(styles.group, styles.column, styles.sideBySide)}>
          <Typography
            variant="body2"
            className={styles.label}
          >
            Item Key:
          </Typography>
          <div className={styles.pre}>
            <Typography
              variant="body2"
              className={styles.value}
            >
              {pathToElement}
            </Typography>
          </div>
        </div>
        <div className={cn(styles.group, styles.column, styles.sideBySide)}>
          <Typography
            variant="body2"
            className={styles.label}
          >
            Item Id:
          </Typography>
          <div className={styles.pre}>
            <Typography
              variant="body2"
              className={styles.value}
            >
              {componentId}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
}

export default ElementDetails;
